import { useMemo } from 'react';
import { createPortal } from 'react-dom';
const Portal = _ref => {
  let {
    children,
    container
  } = _ref;
  const existingRoot = typeof document !== 'undefined' ? document.getElementById('root') : null;
  const target = useMemo(() => {
    if (container instanceof HTMLElement) return container;
    return existingRoot || document.body;
  }, [container, existingRoot]);
  if (!target) return null;
  return createPortal(children, target);
};
export default Portal;